import { render, staticRenderFns } from "./LazyUsers.vue?vue&type=template&id=5ffcbd4c&scoped=true&"
import script from "./LazyUsers.vue?vue&type=script&lang=js&"
export * from "./LazyUsers.vue?vue&type=script&lang=js&"
import style0 from "./LazyUsers.vue?vue&type=style&index=0&id=5ffcbd4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffcbd4c",
  null
  
)

export default component.exports